<template>
  <div id="tramiteConcluido">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-icon small color="primary">drag_indicator</v-icon> Trámite / Concluidos
          </h4>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title>
          <!-- <v-select
            label="Tipo de trámite"
            :items="tipo_tramite"            
            item-value="id"
            item-text="descripcion"
          ></v-select> -->
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
          >
          </v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="concluidos"
          class="elevation-1"
          rows-per-page-text="Filas por página"
          no-data-text="No existen registros"
          no-results-text="Sin resultados"
          page-text="de"
          :rows-per-page-items="[10, 25, 50, 100, {'text': 'Todos', value: -1}]"
          v-bind:search="search"
          v-cloak
        >
          <template v-slot:items="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.flujo }}</td>
            <td>{{ props.item.tramite_tipo }}</td>
            <td>{{ props.item.codigo_tabla }}</td>
            <td>{{ props.item.nombre }}</td>
            <td>{{ props.item.fecha_registro }}</td>
            <td>{{ props.item.fecha_fin }}</td>
            <td>{{ props.item.duracion }}</td>
            <td>
              <v-chip small color="orange lighten-4" v-if="props.item.tramite_tipo_id == 31"><small>CONCLUIDO-EN REGULARIZACIÓN</small></v-chip>
              <v-chip small color="green lighten-4" v-else><small>{{ props.item.estado }}</small></v-chip>
            </td>
            <!-- <td>
              <v-btn
                icon
                dark
                color="primary"
                small
                @click="showDetail(props.item.id, props.item.idflujo)"
              >
                <v-icon small>assignment</v-icon>
              </v-btn>
            </td> -->
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogDetail" scrollable max-width="70%">
        <v-card>
          <v-card-title class="headline grey lighten-3" primary-title>
            <span class="headline">Detalle del trámite</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap>
              <v-flex md6 pb-3>
                <b>Nro. de Trámite</b><br>
                {{tramite.tramite_id}}
              </v-flex>
              <v-flex md6 pb-3>
                <b>Fecha de Finalización</b><br>
                {{tramite.fecha_finalizacion}}
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headerDetail"
              :loading="loadingDetail"
              :items="tramite.detalle"
              class="elevation-1"
              no-data-text="No existen registros"
              hide-actions
              v-cloak
            >
              <template v-slot:items="props">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.flujo }}</td>
                <td>{{ props.item.tramite_tipo }}</td>
                <td>{{ props.item.codigo_tabla }}</td>
                <td>{{ props.item.nombre }}</td>
                <td>{{ props.item.fecha_registro }}</td>
                <td>{{ props.item.fecha_fin }}</td>
                <td>{{ props.item.duracion }}</td>
                <td>
                  <v-chip small color="orange lighten-4" v-if="props.item.tramite_tipo_id == 31"><small>CONCLUIDO-EN REGULARIZACIÓN</small></v-chip>
                  <v-chip small color="green lighten-4" v-else><small>{{ props.item.estado }}</small></v-chip>
                </td>
                <td>
                  djask
                </td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="dialogDetail = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="dialogDetaila" max-width="500px">
      <v-form ref="form">
        <v-card>
          <v-card-title class="headline grey lighten-3" primary-title>
            <span class="headline">Detalle</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            Detalle del tramite
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="mdialog = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog> -->
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
      <v-btn dark flat @click="snack.state = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Service from '../services/general';
import axios from 'axios';
export default {
  name: 'tramite-concluido',
  data() {
    return {
      search: '',
      headers: [
        { text: 'Nro', align: 'left', value: 'id', sortable: false },
        { text: 'Trámite ', value: 'flujo' },
        { text: 'Tipo Trámite ', value: 'tramite_tipo' },
        { text: 'Código ', value: 'codigo_tabla' },
        { text: 'Nombre ', value: 'nombre' },
        { text: 'Fecha Inicio ', value: 'fecha_registro' },
        { text: 'Fecha Fin ', value: 'fecha_fin' },
        { text: 'Duración ', value: 'duracion' },
        { text: 'Estado ', align: 'left', value: 'estado' },
        //{ text: 'Detalle ', align: 'center', sortable: false }
      ],
      headerDetail: [
        { text: 'Nro', align: 'left', value: 'id', sortable: false },
        { text: 'Pasos del Trámite ', value: 'pasos_tramite' },
        { text: 'Fecha Recepción ', value: 'fecha_recepcion' },
        { text: 'Fecha Envío ', value: 'fecha_envio' },
        { text: 'Fecha Vencimiento ', value: 'fecha_vencimiento' },
        { text: 'Duración ', value: 'duracion' },
        { text: 'Plazo ', value: 'plazo' },
        { text: 'Observación ', value: 'observacion' },
        { text: 'Estado ', align: 'left', value: 'estado' },
        { text: 'Usuario Remitente ', align: 'left', value: 'usuario' },
        { text: 'Usuario Destinatario ', align: 'left', value: 'usuario' }
      ],
      loading: false,
      concluidos: [],
      dialogDetail: false,
      loadingDetail: false,
      tramite: {
        tramite_id: '123123124',
        fecha_finalizacion: '',
        detalle: []
      },
      tipo_tramite: [],
      snack: {
        state: false,
        color: 'success',
        mode: '',
        text: ''
      }
    };
  },
  mounted() {
    this.tipo_tramite = [
      {id: 2, descripcion: 'Ratificación'},
      {id: 3, descripcion: 'Ampliación'},
      {id: 4, descripcion: 'Cambio de Razón Social'},
      {id: 5, descripcion: 'Cambio de Domicilio'},
      {id: 6, descripcion: 'Cambio de derecho Propietario'},
      {id: 7, descripcion: 'Cierre del Centro de Capacitación'}
    ];
    this.dparams = Service.getParams();
    if (this.dparams != null) {
      this.getConcluidos();
    }
  },
  computed: {},
  methods: {
    getConcluidos() {
      this.loading = true;
      this.dparams.tipo = 4;
      axios
        .post(Service.getServe() + 'tramite/lista', this.dparams, Service.getHeader())
        .then(response => {
          this.concluidos = response.data.entities;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.error('Error al cargar registros', error);
        });
    },

    showDetail(tramite_id, flujo_tipo_id) {
      this.dialogDetail = true;
      this.loadingDetail = true;
      //console.log(tramite_id, flujo_tipo_id);
    },

    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
  }
};
</script>